
import moment from 'moment';
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import {
  CancelledConnection,
  Connection,
} from '@/types';
import CancelledConnectionDetailsDialog from './CancelledConnectionDetailsDialog.vue';

moment.locale('it');

@Component({
  components: {
    CancelledConnectionDetailsDialog,
  },
})
export default class CancelledConnectionDetailsIcon extends Vue {
  @Prop(Object) readonly connection!: Connection;
  @Prop(Object) readonly cancelledConnection!: CancelledConnection;

  detailsDialog = false

  onDetails() {
    this.detailsDialog = true;
  }
}
